// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"ReturnToApp_paragraph__1nHxM","button":"ReturnToApp_button__ay3uf"};